import React from "react";
import { CheckCircle, Clock, Mail } from "lucide-react";

export interface UserOptionPreviewProps {
  label: string;
  email?: string;
  available_hours?: number;
  is_active?: boolean;
  is_billable?: boolean;
  hourly_rate?: number;
}

export function UserOptionPreview({
  label,
  email,
  available_hours,
  is_active,
  is_billable,
  hourly_rate,
}: UserOptionPreviewProps) {
  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="flex items-center gap-2">
        <span className="font-medium">{label}</span>
        {is_active === false && (
          <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Inactive
          </span>
        )}
        {is_billable && (
          <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200">
            Billable
          </span>
        )}
      </div>
      <div className="flex flex-col gap-1 text-xs text-muted-foreground">
        {email && (
          <div className="flex items-center gap-1">
            <Mail className="h-3 w-3" />
            <span className="truncate">{email}</span>
          </div>
        )}
        {available_hours !== undefined && (
          <div className="flex items-center gap-1">
            <Clock className="h-3 w-3" />
            <span>{available_hours} hrs/week</span>
          </div>
        )}
        {hourly_rate !== undefined && hourly_rate > 0 && (
          <div className="flex items-center gap-1">
            <CheckCircle className="h-3 w-3" />
            <span>${hourly_rate}/hr</span>
          </div>
        )}
      </div>
    </div>
  );
}
